import * as yup from 'yup';
import * as utils from './utils';
import { Produit } from '../entities';

export const schemaProduit = yup.object<Partial<Produit>>({
    fk_id_fournisseur:yup.number().required("Le produit associé est obligatoire"),
    name: yup.string().required('Ce champ est requis'),
    description_produit: yup.string().nullable(),
    actif: yup.boolean().nullable().default(true).transform(utils.nullBoolToFalse),
    notes_internes: yup.string().nullable(),
    notes_client: yup.string().nullable(),
    notes_fournisseur: yup.string().nullable(),
    created_at: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    date_derniere_modification: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform))
}) as yup.ObjectSchema<Partial<Produit>>;
